export const EVENT_LOGIN = "EVENT_LOGIN"
export const EVENT_LOGIN_SUCCESS = "EVENT_LOGIN_SUCCESS"
export const EVENT_LOGIN_ERROR = "EVENT_LOGIN_ERROR"
export const EVENT_LOGOUT = "EVENT_LOGOUT"

export const ADD_USER_DETAILS_SETTINGS = "ADD_USER_DETAILS_SETTINGS"


export function addUserDetails(ds) {
  return {
    type: ADD_USER_DETAILS_SETTINGS,
    data: ds
  }
}

export function logout() {
  return {
    type: EVENT_LOGOUT,
    data: {}
  }
}

export function login() {
  return {
      type: EVENT_LOGIN,
      data: {}
  }
}
export function loginerror(error) {
  return {
    type: EVENT_LOGIN_ERROR,
    data: error
  }
}
export function loginsuccess(token) {
  return {
    type: EVENT_LOGIN_SUCCESS,
    data: token
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/authactions.js